import { useQuery } from '@abyss/web/hooks/useQuery';
// @ts-ignore
import { ApiUrl } from '@src/common/ajax/apiUrl';
import CreateFFCProvider from './CreateFFCProvider.gql';

export const useCreateFFCProvider = (options) => {
  return useQuery(CreateFFCProvider, {
    ...options,
    url: ApiUrl.graphQl(),
  });
};
